import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function PageNotFound(props) {
  const { t: tCommon } = useTranslation("common");

  return (
    <Container
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Typography component="div" variant="h3">
        {tCommon("This page is not available now.")} <Link to="/">{tCommon("Click here")}</Link> {tCommon("to go to home")}.
      </Typography>
    </Container>
  );
}
